import { connect } from 'react-redux'

import { selectItem, setOffsetTop } from '../../../../common/actions/layout'
import ItemCard from './'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    selectItem: item => {
      dispatch(selectItem(item))
    },
    resetOffsetTop: () => {
      dispatch(setOffsetTop(null))
    }
  }
}

const PhotoduneGridItemCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemCard)

export default PhotoduneGridItemCardContainer
